import { Platform } from '../platforms.js';

// 适配器注册表：保存当前平台对应的适配器实例
let currentAdapter = null;
let currentPlatform = null;

export function setAdapter(adapter) {
  currentAdapter = adapter;
  currentPlatform = adapter && adapter.platform;
}

export function getAdapter() {
  return currentAdapter;
}

export function getPlatform() {
  return currentPlatform;
}

export function hasAdapter() {
  return currentAdapter !== null;
}
